import * as yup from "yup";

export type FormValues = yup.Asserts<typeof validationSchema>;

export const validationSchema = yup.object({
  source: yup.string().required(),
  parameterName: yup.string().required(),
  parameterValue: yup.string().required(),
});
